import { useMemo } from 'react';
import AddJobsByMap from './AddJobsByMap';
import { AddJobsRecord } from '../../routingApi';

type Props = {
  jobs: AddJobsRecord[] | undefined;
  initialMapViewState: any;
};

const AddJobsByMapPreRender = ({ jobs, initialMapViewState }: Props) => {
  const memoizedComponent = useMemo(() => {
    if (!jobs) return null;

    return (
      <AddJobsByMap
        onClose={() => {}} 
        onNext={() => {}} 
        jobs={jobs}
        initialMapViewState={initialMapViewState}
        initialSelectedJobs={[]}
        isPreRender={true}
        isOpen={false}
      />
    );
  }, [jobs, initialMapViewState]);

  return memoizedComponent;
};

export default AddJobsByMapPreRender;